import CustomButton from "common/components/Button/Button"
import ButtonsToggle from "common/components/ButtonsToggle"
import CustomConfirmDialog from "common/components/ConfirmDialog"
import Spinner from "common/components/Spinner/Spinner"
import notification from "common/utils/notification"
import PanelsHeader from "features/Contactos/components/PanelsHeader"
import AprovalsModal from "features/User/pages/ApprovalsManagement/components/AprovalsModal"
import {
  DOC_TITLE_PLURAL,
  DOC_TYPES_KEYS,
  generarteValidationsList,
} from "features/User/pages/ApprovalsManagement/constants"
import { approvalsServices } from "features/User/pages/ApprovalsManagement/services/approvals"
import {
  getApprovalStatus,
  getApprovals,
} from "features/User/redux/selectors/approvalsSelectors"
import { fetchApprovalsByContacto } from "features/User/redux/slices/approvalSlices"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import ValidationElement from "../../components/ValidationElement"

const FormValidaciones = ({ contactoId }: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [show, setShow] = useState({ id: null, status: false })
  const [showDelete, setShowDelete] = useState({ id: null, status: false })
  const dispatch = useDispatch()
  const aprobaciones = useSelector(getApprovals)
  const aprobacionesStatus = useSelector(getApprovalStatus)
  const [tabSelected, setTabSelected] = useState(DOC_TYPES_KEYS(t)[2].value)
  const newArray = generarteValidationsList(aprobaciones, t).filter(
    (flow) => flow.value === tabSelected && flow.flujoAprobaciones.length
  )

  const onRenderButtonsOptions = useMemo(() => {
    return [
      {
        id: 1,
        handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[2].value),
        label: DOC_TITLE_PLURAL(t).Factura,
        disabled: false,
      },
      {
        id: 2,
        handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[18].value),
        label: DOC_TITLE_PLURAL(t).Albarán,
        disabled: false,
      },
      {
        id: 3,
        handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[24].value),
        label: DOC_TITLE_PLURAL(t).Pedido,
        disabled: false,
      },
      {
        id: 4,
        handleClick: () => setTabSelected(DOC_TYPES_KEYS(t)[25].value),
        label: DOC_TITLE_PLURAL(t).Presupuesto,
        disabled: false,
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    contactoId && dispatch(fetchApprovalsByContacto(contactoId))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactoId, dispatch, fetchApprovalsByContacto])

  const handleModal = (id: $TSMigrationFixMe) => {
    setShow({ id: id || null, status: !show.status })
  }
  const handleModalDelete = (id: $TSMigrationFixMe) => {
    setShowDelete({ id: id || null, status: !showDelete.status })
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const handleCreateUpdateApproval = async (values: $TSMigrationFixMe) => {
    const data = { ...values, contactoId }
    try {
      show.id
        ? await approvalsServices.updateApproval(data)
        : await approvalsServices.createApproval(data)
      notification.success({
        body: `${
          show.id
            ? t("notification.flowSucessEdit")
            : t("notification.flowSucessCreated")
        }`,
      })
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      handleModal()
      dispatch(fetchApprovalsByContacto(contactoId))
    } catch (err) {
      return err
    }
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const handleDeleteApproval = async () => {
    try {
      await approvalsServices.deleteApproval(showDelete.id)

      notification.success({ body: `${t("notification.flowSuccessDelete")}` })
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      handleModalDelete()
      dispatch(fetchApprovalsByContacto(contactoId))
    } catch (err) {
      return err
    }
  }

  return (
    <>
      <PanelsHeader title={t("contactos.editar.dataAdvance.validationLabel")} />
      <section>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='contactos-validaciones__switch'>
            <ButtonsToggle headerGroupItems={onRenderButtonsOptions} />
          </div>

          <CustomButton
            className='tw-ml-2 !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
            onClick={() => handleModal()}
          >
            {t("contactos.editar.dataAdvance.newFlowButton")}
          </CustomButton>
        </div>
        <div className='mt-3 p-fluid board__container'>
          {aprobacionesStatus ? (
            <div className='d-flex w-100'>
              <Spinner />
            </div>
          ) : (
            <>
              {newArray?.length
                ? // @ts-expect-error TS(7006): Parameter 'flujo' implicitly has an 'any' type.
                  // eslint-disable-next-line @typescript-eslint/no-unused-vars
                  newArray[0].flujoAprobaciones?.map((flujo, i) => {
                    return (
                      <ValidationElement
                        key={flujo.departamentoNombre}
                        flujo={flujo}
                        documentoNombre={newArray[0].tipoDocumentoNombre}
                        handleEdit={() => handleModal(flujo.id)}
                        handleRemove={() => handleModalDelete(flujo.id)}
                      />
                    )
                  })
                : null}
            </>
          )}
        </div>
      </section>
      <AprovalsModal
        show={show}
        setShow={handleModal}
        sendRequest={handleCreateUpdateApproval}
      />
      <CustomConfirmDialog
        visible={showDelete.status}
        onHide={handleModalDelete}
        closable
        message={
          <span>{t("contactos.editar.dataAdvance.deleteMsgFlow")}&quot;?</span>
        }
        header={
          <div className='d-flex justify-content-start'>
            <h6>{t("contactos.editar.dataAdvance.deleteFlowButton")}</h6>
          </div>
        }
        acceptLabel={t("contactos.editar.dataAdvance.acceptLabel")}
        rejectLabel={t("contactos.editar.dataAdvance.denegateLabel")}
        accept={handleDeleteApproval}
      />
    </>
  )
}

export default FormValidaciones
